import type { SVGProps } from 'react';

const PaymentApplePay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="24"
    fill="none"
    data-name="Apple Pay"
    viewBox="0 0 34 24"
    {...props}
  >
    <rect width={33} height={23} x={0.5} y={0.5} fill="#fff" stroke="#D9D9D9" rx={3.5} />
    <path
      fill="#000"
      d="M12.1 5.6c.4-.5 1-.9 1.7-.9.1.8-.2 1.5-.6 2-.4.5-1 .9-1.7.8-.1-.7.2-1.4.6-1.9Z"
    />
    <path
      fill="#000"
      d="M14.2 7.5c.9 0 1.3.5 2.1.5.7 0 1.2-.5 2.2-.5 1.1 0 2.3.9 2.3 2.8 0 2.2-1.9 5-3.2 5-.7 0-1-.5-1.9-.5-.8 0-1.2.5-2 .5-1.4 0-3.1-2.6-3.1-4.8 0-1.9 1.1-3.1 2.6-3.1.7 0 1.2.5 1.9.5.4 0 .7-.4 1.1-.4Z"
    />
    <path
      fill="#000"
      d="M23 8h1.6c.6 0 1 .4 1 .9 0 .6-.4 1-1 1H23.7v1.4H23V8Zm.7.5v.9h.8c.3 0 .5-.2.5-.5s-.2-.4-.5-.4h-.8ZM26 10.7l1-2.7h.7l1 2.7h-.7l-.2-.6h-1l-.2.6H26Zm1-2.1-.4 1h.7l-.3-1ZM28.9 9.2l-.5-1.2h.7l.4.9.4-.9h.6l-.9 2.1v1.2h-.7V11l-.5-1.1.5-.7Z"
    />
  </svg>
);
export default PaymentApplePay;
